
export interface IOrderableIdentified<T> {
  readonly id: T; //number | string;
}

export default class LocalStoreOrder {
  constructor(private key_: string) { }

  saveOrder<T>(arr: IOrderableIdentified<T>[], suffix = "") {
    const ids = JSON.stringify(arr.map(s => s.id));
    localStorage.setItem(this.key_ + suffix, ids);
  }

  loadOrder<T>(suffix = ""): T[] {
    const ids = localStorage.getItem(this.key_ + suffix);
    if (!ids) return [];
    return (JSON.parse(ids) || []) as T[];
  }

  reorder<TId, T extends IOrderableIdentified<TId>>(arr: T[], suffix = ""): T[] {
    const order = this.loadOrder(suffix);
    const reordered: T[] = [];
    for (const id of order) {
      const i = arr.findIndex(s => s.id === id);
      if (i >= 0) {
        reordered.push(arr[i]);
        arr.splice(i, 1);
      }
    }
    return [...reordered, ...arr];
  }
} 